import { MessageSquare } from 'lucide-react'

// Painel direito vazio — no mobile a lista ocupa a tela toda e isto não aparece.
export default function AtendimentoVazio() {
  return (
    <div
      style={{
        flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', color: 'var(--muted)', background: 'var(--bg)', padding: 24,
      }}
    >
      <MessageSquare size={54} aria-hidden style={{ opacity: .35, marginBottom: 14 }} />
      <div style={{ fontSize: 15 }}>Selecione uma conversa para começar</div>
    </div>
  )
}
